import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApi.get("/api/transform/histories", { params });
};

const transformHistoryService = {
  getAll
};

export default transformHistoryService;